<div class="app-navbar">
  @if (showLogo) {
    <div>
      @if (isInlineLogo) {
        <!-- NgOptimizedImage rejects data: URLs, so admin-uploaded logos use a plain img -->
        <img
          id="organizationLogo"
          [height]="logoHeight"
          [width]="logoWidth"
          [src]="isDarkTheme ? logoDarkPath : logoLightPath"
          alt="logo"
        />
      } @else {
        <img
          id="organizationLogo"
          [height]="logoHeight"
          [width]="logoWidth"
          [ngSrc]="isDarkTheme ? logoDarkPath : logoLightPath"
          alt="logo"
        />
      }
    </div>
  }
  <div class="ms-auto">
    <ix-col>
      <ix-dropdown-button
        id="navbarLanguageDropdown"
        label="{{ getSelectedLanguageNativeName() }}"
        variant="subtle-tertiary"
        class="me-1"
        >
        @for (lang of availableLanguages; track lang.code) {
          <ix-dropdown-item
            id="{{ 'navbarLanguageDropdownItem.' + lang.code }}"
            (click)="changeLanguage(lang.code)"
            onkeypress=""
            label="{{ lang.nativeName }}"
            >
          </ix-dropdown-item>
        }
      </ix-dropdown-button>
    </ix-col>
    <ix-icon-button
      id="navbarThemeSwitcher"
      class="me-1"
      icon="light-dark"
      variant="subtle-tertiary"
      (click)="onToggleThemeClick()"
      onkeypress=""
    ></ix-icon-button>
    <a [href]="'links.contact_link' | translate" target="_blank">
      <ix-icon-button
        icon="question"
        id="navbarHelp"
        variant="subtle-tertiary"
      ></ix-icon-button>
    </a>
  </div>
</div>
